import React, { useEffect } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import { useRouter, useSearchParams } from 'src/routes/hooks';

export function Logout() {
  const { logout } = useAuthContext();
  const router = useRouter();
  const searchParams = useSearchParams();

  const returnTo = searchParams.get('returnTo');

  useEffect(() => {
    logout();
    router.replace(`/auth/login${returnTo ? `?returnTo=${returnTo}` : ''}`)
  }, []);
  return <div />;
}
